import styled from "styled-components"
import useSystemNavigation from "../../SysHooks"

const Wrapper = styled.div`
  &.flex-container {
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    height: 70vh;

    .text-center {
      text-align: center;

      h1,
      h3 {
        margin: 10px;
        cursor: default;
      }

      button {
        border: 1px solid black;
        background: transparent;
        outline: none;
        padding: 10px 20px;
        font-size: 1.1rem;
        font-weight: bold;
        color: black;
        text-transform: uppercase;
        transition: background-color 200ms ease-in;
        margin: 20px 0;

        &:hover {
          color: #555;
          cursor: pointer;
        }
      }
    }
  }
`

const PageNotFound = () => {
//   const { goHome } = useSystemNavigation()

  return (
    <Wrapper className="flex-container">
      {/* <div className="text-center">
        <h1>
          DEVELOPMENT <br /> IN PROGRESS
        </h1>

        <button type="button" name="button" onClick={goHome}>
          Return To Home
        </button>
      </div> */}
    </Wrapper>
  )
}

export default PageNotFound
